module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles-to-rhombuses-spinner",
    style: (_vm.spinnertStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db034316"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/CirclesToRhombusesSpinner.vue
// module id = 2284
// module chunks = 1